import { Alert, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, ListItemIcon, ListItemText, Menu, MenuItem, MenuList, Paper, Popper, Snackbar } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import TranslateOutlined from '@mui/icons-material/TranslateOutlined';
import { ChevronRightOutlined } from '@mui/icons-material';
import Box from '@mui/material/Box';
import React from 'react'
import { withTranslation } from 'react-i18next';
import API from '../api/api';
import { _clampToMaxLength } from '../helper';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateAutoTranslations } from '../modules/shop';
import DontAskAgainDialog from './DontAskAgainDialog';
import OutOfWordsQuotaDialog from './OutOfWordsQuotaDialog';
import { UpgradePlanHint } from './PricingPlans';

class SourceToTargetMenu extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      loadingTranslations: false,
      anchorEl : null
    }

    this.importFromOriginal = this.importFromOriginal.bind(this);
  };
  
  showImportFromOriginalDialog = () => {
    this.setState({showImportFromOriginalDialog: true})
  }
  closeImportFromOriginalDialog = () => {
    this.setState({showImportFromOriginalDialog: false})
  }
  importFromOriginal = () => {
    if(this.props.data.target != this.props.data.source) {
      this.setState({usedText: this.props.data.source})

      this.props.onChange(null, {
        id: this.props.data.id,
        changed: true,
        initial: this.props.data.target,
        target: this.props.data.source,
        parentField: this.props.parentField,
      });

      this.props.onTriggerForceUpdate();
    }
    
    this.setState({showImportFromOriginalDialog: false});
  }

  updateAnchorEl = (anchorEl) => {
    this.setState({
      anchorEl: anchorEl
    })
  }

  closeAutoTranslateNotificationsWarning = () => {
    this.setState({showAutoTranslateNotificationsWarning: false})
  }

  autoTranslateField = async (force = false) => {
    //debugger;
    if(!force && window.location.href.includes('notifications')) {
      this.setState({showAutoTranslateNotificationsWarning: true});

      return;
    }

    let root = this;
    const { from, to } = this.props;

    // Collect all section source strings in an array
    let stringsArr = {};
    stringsArr[this.props.data.id] = this.props.data.source.toString();

    // Handle events that block the process
    const runToken = API.runToken;
    const wordCountRes = await new Promise(resolve => API.autoTranslateWordCount(from, to, stringsArr, resolve));
    // The merchant switched while the count was out - stop before the paid request goes out
    if(API.runToken !== runToken) {
      this.setState({ loadingTranslations: false });
      return;
    }
    // A failed count read as zero words would pass the quota check and send
    // the paid request on the strength of an error.
    if(!wordCountRes || wordCountRes.success === false) {
      this.setState({ loadingTranslations: false, loadingTranslationsError: true, errorMessage: wordCountRes?.show_message || null });
      return;
    }
    // the service names the strings it leaves as they are (skip_details); sent anyway, this
    // field would come back without a result and the request as a whole as an error
    const serviceSkip = (wordCountRes.skip_details?.fields || []).find(entry => String(entry?.key) === String(this.props.data.id));
    if(serviceSkip) {
      this.closeMenu();
      this.setState({ loadingTranslations: false, skippedReason: serviceSkip.reason || '' });
      return;
    }
    let wordsToTranslateNum = wordCountRes.word_count ?? 0;
    let hasMuchHtml = this.checkHtmlAmount(stringsArr);
    let outQuota = wordsToTranslateNum > this.props.shop.shop.auto_translations.available_words;
    if((hasMuchHtml && !force) || outQuota) {
      this.setState({
        showNotEnoughWordsDialog: false,
        showMuchHtmlNotice: false,
      }, () => {
        this.setState({
          loadingTranslations: false,
          showNotEnoughWordsDialog: outQuota,
          showMuchHtmlNotice: hasMuchHtml && !outQuota,
        });
      });
      return;
    }

    // Call API Servie and manage response
    this.setState({
      loadingTranslations: true,
    })

    API.autoTranslateStrings(from, to, stringsArr, (res) => {
      if(res.success === false || !res.auto_translations) {
        root.setState({
          loadingTranslations: false,
          loadingTranslationsError: true,
          errorMessage: res?.show_message || null,
        });
        return null;
      }

      root.props.updateAutoTranslations(
        res.auto_translations.total_used_words,
        res.auto_translations.available_words,
      )

      // no result for the field: the service left it as it is - keep the target rather than
      // writing undefined into it
      if(res.Strings?.[root.props.data.id] === undefined) {
        root.setState({ loadingTranslations: false, skippedReason: '' });
        return null;
      }
      // cut to the field's hard limit like the section-wide run does: the input's maxLength only
      // stops typing, and Shopify silently drops a too-long value (alt texts: 512) on save
      const translation = _clampToMaxLength(res.Strings[root.props.data.id], root.props.data.maxLength);
      root.setState({
        usedText: translation,
        loadingTranslations: false,
        loadingTranslationsError: false,
      });

      root.props.onChange(null, {
        id: root.props.data.id,
        changed: true,
        initial: root.props.data.target,
        target: translation,
        parentField: root.props.parentField,
      });

      root.props.onTriggerForceUpdate();
    });

  }

  countWords = (arr, calcOverflow) => {
    let deleteEmptySliceValues = function(inputArray) {
      var r = [];
      inputArray.forEach(function(item) {
        if (item !== "") {
          r.push(item);
        }
      });
      return r
    }

    let sum = Object.values(arr).reduce((pv, cv, ci) => {
      let singleSourceString = cv.toString();
      let charCount = singleSourceString.length;
      let calc_words_by_chars = charCount / 6;
      singleSourceString = singleSourceString.replace(/-/g, " ");
      singleSourceString = singleSourceString.replace(/</g, " ");
      singleSourceString = singleSourceString.replace(/>/g, " ");
      singleSourceString = singleSourceString.replace(/\"/g, " ");
      singleSourceString = singleSourceString.replace(/\n/g, " ");
      let wordSlice = singleSourceString.split(" ");
      wordSlice = deleteEmptySliceValues(wordSlice);

      let diff = calc_words_by_chars - wordSlice.length;
      if (diff < 0) diff = diff * -1;
      let diffPercent = (diff * 100) / wordSlice.length
      let price_words = wordSlice.length;
      if (diffPercent > 10 && calc_words_by_chars > wordSlice.length) {
          price_words = calc_words_by_chars;
      }
      let totalWords = pv + parseInt(price_words);

      return totalWords;
    }, 0);
    return sum;
  }

  checkHtmlAmount = (arr) => {
    if(localStorage.getItem('ly_not_ask_again_MuchHtmlNotice')) {
      return false;
    }
    let htmlCount = 0;
    Object.entries(arr).map((item) => {
      if(item[0] === 'body_html' || item[0] === 'summary_html') {
        let plainTxt = item[1].replace(/<[^>]*>?/gm, '');
        let allWords = this.countWords({[item[0]]: item[1]});
        let txtWords = this.countWords({txt: plainTxt});
        let count = allWords - txtWords;
        if(count > htmlCount) htmlCount = count;
      }
    });
    return htmlCount > 250 ? true : false;
  }

  closeSkippedNotice = () => {
    this.setState({ skippedReason: undefined });
  }
  // the service's reason as the dialog table shows it on hover: capitalised, no trailing dot of its own
  reasonText = (reason) => { const r = String(reason || '').trim(); return r ? r.charAt(0).toUpperCase() + r.slice(1) : ''; };

  closeMuchHtmlNotice = () => {
    this.setState({showMuchHtmlNotice: false});
  }
  cancelMuchHtmlNotice = () => {
    this.setState({showMuchHtmlNotice: false});
  }
  submitMuchHtmlNotice = () => {
    if(!this.state.showNotEnoughWordsDialog) {
      this.autoTranslateField(true);
    }
  }

  componentDidMount = () => {

    this.setState({
      source: this.props.data.source,
      target: this.props.data.target
    })

    if (this.props.onLoaded) {
      setTimeout(() => {
        if (this.hasMounted) {
          this.props.onLoaded()
        }
      }, 100)
    }
  }

  // variant="menu": the actions as items of a Menu the field anchors on its kebab button, extra
  // items (mode switch, delete, field info) come as children. The arrow-hover variant stays for
  // callers that render no kebab (SEO fields).
  componentDidUpdate(prevProps, prevState) {
    if(this.props.variant === 'menu' && prevState.loadingTranslations && !this.state.loadingTranslations) {
      this.props.onClose && this.props.onClose();
    }
  }

  renderDialogs() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <DontAskAgainDialog
          context="ImportFromOriginal"
          open={this.state.showImportFromOriginalDialog}
          onClose={this.closeImportFromOriginalDialog}
          onSubmit={this.importFromOriginal}
          title={t('itemsList.importFromOriginal')}
          content={t('itemsList.importFromOriginalDescription')}
        />
        <DontAskAgainDialog
          context="showAutoTranslateNotificationsWarning"
          open={this.state.showAutoTranslateNotificationsWarning}
          onClose={this.closeAutoTranslateNotificationsWarning}
          onSubmit={() => {this.autoTranslateField(true)}}
          title={t('itemsList.notificationNoticeTitle')}
          content={t('itemsList.notificationNoticeDescription')}
        />
        <DontAskAgainDialog
          context="MuchHtmlNotice"
          open={this.state.showMuchHtmlNotice}
          onClose={this.closeMuchHtmlNotice}
          onCancel={this.cancelMuchHtmlNotice}
          onSubmit={this.submitMuchHtmlNotice}
          title={t('itemsList.htmlInContentTitle')}
          content={t('itemsList.htmlInContentDescription')}
          initialChecked
        />
        <OutOfWordsQuotaDialog
          open={this.state.showNotEnoughWordsDialog}
        />
        <Dialog open={this.state.skippedReason !== undefined} onClose={this.closeSkippedNotice}>
          <DialogTitle>{t('itemsList.autoTranslateSingleFieldSkippedTitle')}</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {this.reasonText(this.state.skippedReason)
                ? t('itemsList.autoTranslateSingleFieldSkipped', { reason: this.reasonText(this.state.skippedReason) })
                : t('itemsList.autoTranslateSingleFieldSkippedNoReason')}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" onClick={this.closeSkippedNotice} autoFocus>{t('system.close')}</Button>
          </DialogActions>
        </Dialog>
        <Snackbar open={this.state.loadingTranslationsError === true} autoHideDuration={6000} onClose={this.closeErrorNotice}>
          <Alert onClose={this.closeErrorNotice} severity="error" elevation={6} variant="filled">
            {this.state.errorMessage || t('system.whoopsMessage')}
          </Alert>
        </Snackbar>

      </React.Fragment>
    );
  }

  closeErrorNotice = () => {
    this.setState({ loadingTranslationsError: false });
  }

  // closes whichever variant is open: the kebab's Menu through onClose, the arrow's Popper by its anchor
  closeMenu = () => {
    this.props.onClose && this.props.onClose();
    // the list unmounts under the pointer without a mouseleave: a stale flag kept the next hover's popper open
    this.mouseIsOver = false;
    this.setState({ anchorEl: null });
  }

  // the actions both variants share - the kebab's Menu and the arrow's hover Popper render this
  // same list, so an entry changed here changes in both
  renderActionItems() {
    const { t, to } = this.props;
    const loading = this.state.loadingTranslations;
    return [
      <MenuItem key="import" dense disabled={loading} onClick={() => { this.closeMenu(); this.showImportFromOriginalDialog(); }}>
        <ListItemIcon><ContentCopyIcon fontSize="small" /></ListItemIcon>
        <ListItemText>{t('itemsList.importFromOriginal')}</ListItemText>
      </MenuItem>,
      to !== 'IA' && (
        <MenuItem
          key="translate"
          dense
          disabled={loading || this.props.shop.shop.charge.name === 'free'}
          onClick={() => this.autoTranslateField(false)}
        >
          <ListItemIcon>{loading ? <CircularProgress size={18} /> : <TranslateOutlined fontSize="small" />}</ListItemIcon>
          <ListItemText>{t('itemsList.autoTranslateSingleField')}</ListItemText>
        </MenuItem>
      ),
    ];
  }

  // editItems: further ways of editing the target, listed with import / machine translation above
  // the divider; the kebab only, the arrow's hover list stays with the shared two
  renderMenu() {
    const { anchorEl, onClose, children, editItems } = this.props;
    const loading = this.state.loadingTranslations;
    return (
      <React.Fragment>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={loading ? undefined : onClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          {this.renderActionItems()}
          {editItems}
          {children && <Divider />}
          {children}
        </Menu>
        {this.renderDialogs()}
      </React.Fragment>
    );
  }

  render() {
    if(this.props.variant === 'menu') {
      return this.renderMenu();
    }

    const { deletable, centered, arrowStyle } = this.props;
    const rightArrowMargin = deletable === true ? "9px": "11px";
    const leftArrowMargin = deletable === true ? "-19px": "inherit";
    const open = Boolean(this.state.anchorEl);

    return (
      <React.Fragment>
        <Box
          component="span"
          onMouseOver={event => {
            this.updateAnchorEl(event.currentTarget)
          }}
          onMouseLeave={() => {
            setTimeout(() => {
              if (!this.mouseIsOver) {
                this.updateAnchorEl(null)
              }
            }, 200)
          }}
          data-tour="source-to-target-arrow"
          sx={[styles.arrow, centered && styles.arrowCentered, {
            zIndex:"1",
            marginRight: rightArrowMargin,
            marginLeft: leftArrowMargin
          }, arrowStyle]}>
          <ChevronRightOutlined
            onClick={event => {
              this.updateAnchorEl(event.target)
            }}
          />
          {this.state.loadingTranslations && (
            <CircularProgress
              size={24}
              sx={styles.autoTranslationProgress}
            />
          )}
        </Box>
        <Popper
          id="render-props-popover"
          open={open}
          anchorEl={this.state.anchorEl}
          onClose={() => {
            this.updateAnchorEl(null)
          }}
          anchororigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
          transformorigin={{
            vertical: 'top',
            horizontal: 'center'
          }}
          style={{ zIndex: '20000 !important' }}>
          <Paper>
            <MenuList
              dense={true}
              onMouseEnter={event => {
                this.mouseIsOver = true
              }}
              onMouseLeave={() => {
                this.mouseIsOver = false
                this.updateAnchorEl(null)
              }}>
              {this.renderActionItems()}
            </MenuList>
          </Paper>
        </Popper>

        {this.renderDialogs()}
      </React.Fragment>
    )
  }
}

const mapStateToProps = ({ shop, languages }) => ({
  shop: shop,
  languages: languages,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      updateAutoTranslations
    },
    dispatch
  )

const styles = {
  arrow: (theme) => ({
    position: 'absolute',
    cursor: 'pointer',
    left: 'calc(50% - 12px)',
    top: 'calc(50% - 12px)',
    transform: 'translateY(-50%)',
    color: theme.palette.text.secondary,
    [theme.breakpoints.down('md')]: {
      display: 'none'
    },
  }),
  /**
   * Opt-in für Feldzeilen, deren umgebender Container exakt so hoch ist wie das
   * Feld selbst (aktuell nur die SEO-Felder, siehe SeoFields.js). Dort ergibt
   * die Standard-Positionierung einen Versatz von 14px nach oben.
   * `display: flex` verhindert zusätzlich die Baseline-Lücke unter dem SVG.
   */
  arrowCentered: (theme) => ({
    top: '50%',
    // Nur ab md: unterhalb bleibt das display:none aus styles.arrow bestehen.
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    },
  }),
  autoTranslationProgress: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(SourceToTargetMenu))
